import React, {Component} from 'react';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import Modal from "../generic/modal";
import _ from 'lodash';
import Toggle from "material-ui/Toggle";
import ReactTooltip from 'react-tooltip';

const EMAIL_REGEX =  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export default class DeliveryConfig extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            isLoaded: true,
            activeLocation: null,
            feeMatrix: [],
            coordinates: [],
            defaultIndex: 0,
            feeIndex: 0,
            isBtnDisabled: true,
            feeTypeFixed: false,
            addDeliveryFeeConfig: false,
            editDeliveryZone: false,
            isEditableRowEnabled: false,
            modalTitle: "",
            isDeliveryInfoUpdated: false,
            successMsg: "",
            editDeliveryFeeConfig: false,
            showZoneModal: false,
            feeTypeActive: false,
            allowZoneOverLap: false,
            minAmount: "",
            deliveryInfoObj: {},
            taxDeliveryFee: true,
            deliveryFeeObj: {
                priceStart: "",
                priceEnd: "",
                fee: "",
                rangeStart: 0,
                rangeEnd: 0
            },
            isEmailNotificationEnabled: false,
            toggleNotifyModal: false
        }

        this._bind(
            'addNewZone',
            'renderDeliveryConfigRow',
            'removeDeliveryConfigUI',
            'renderDeliveryFeeRow',
            'handleChange',
            'handleFeeTypeChange',
            'handleCancel',
            'reloadDeliveryInfoConfig',
            'handleEditableRow',
            'editDeliveryZone',
            'validateAddNewZoneFields',
            'validateDeliveryZone',
            'validateEditTableRowValues',
            'validateDeliveryRangeFields',
            'validateFieldsValues',
            'validateOrderAmountOverlap',
            'validateDeliveryZoneOverlap',
            'setMinAmount',
            'handleTaxOnDeliveryFee',
            'deleteDeliverySettings',
            'deleteDeliveryZone',
            'deleteDeliveryFee',
            'adjustDeliveryFeeOverLapValue',
            'adjustDeliveryZoneOverLapValue',
            'sortDeliveryFeeMatrix',
            'closeNotificationModal'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentWillMount() {
        this.setState({
                activeLocation: this.props.activeLocation,
                isDeliveryInfoUpdated: this.props.isDeliveryInfoUpdated,
                isLoaded: this.props.isLoaded
            },
            () => {
                this.reloadDeliveryInfoConfig();
            });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded === true) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    isDeliveryInfoUpdated: nextProps.isDeliveryInfoUpdated,
                    isLoaded: nextProps.isLoaded
                },
                () => {
                    this.reloadDeliveryInfoConfig();
                });
        }
    }

    //setMinAmount in delivery setting.
    setMinAmount(){
        let feeMatrix = this.state.feeMatrix;
        let fields = this.state.fields;
        let minAmount = [];

        feeMatrix.forEach((el, i) => {
            let feeArray = el.feeArray;

            feeArray.forEach((element, index) => {
                minAmount.push(element.priceStart);
            })
        })

        let min = 0;

        if(minAmount.length > 0){
            // Get the minimum amount from array
            min = Math.min(...minAmount);
        }

        fields["minAmount"] = min;

        this.setState({ fields: fields });

    }


    //reload the delivery config after location change/update
    reloadDeliveryInfoConfig(){
        let activeLocation = this.state.activeLocation;
        // Deep Clone of Delivery Info Object to update the value in local
        let deliveryInfoConfig = _.cloneDeep(activeLocation.deliveryInfo);
        let coordinatesArray = [];
        let fields = this.state.fields;
        let taxOnDeliveryFee = true;
        let isEmailNotificationEnabled = false;

        if (!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(deliveryInfoConfig)) {
            let deliveryInfoConfigShallowCopy = activeLocation.deliveryInfo;
            let feeMatrixObj = deliveryInfoConfig.feeMatrix;

            let sortedFeeMatrix = this.sortDeliveryFeeMatrix(feeMatrixObj);

            //check if coordinates key is present in deliveryInfo
            //if it exists then set its value
            if (deliveryInfoConfig.hasOwnProperty("coordinates")) {
                coordinatesArray = deliveryInfoConfig.coordinates;
            }

            if (deliveryInfoConfig.hasOwnProperty("taxDeliveryFee")) {
                taxOnDeliveryFee = deliveryInfoConfig.taxDeliveryFee;
            }

            if(deliveryInfoConfig.hasOwnProperty("notifyEmail") && !Utils.isEmpty(deliveryInfoConfig.notifyEmail)){
                isEmailNotificationEnabled = true;
            }

            this.setState({
                fields: deliveryInfoConfig,
                feeMatrix: sortedFeeMatrix,
                taxDeliveryFee: taxOnDeliveryFee,
                coordinates: coordinatesArray,
                isEmailNotificationEnabled: isEmailNotificationEnabled
            });

        }else{
            //set state empty anything changes in nextProps.
            this.setState({
                fields: {},
                feeMatrix: [],
                coordinates: coordinatesArray,
                taxDeliveryFee: taxOnDeliveryFee,
                isEmailNotificationEnabled: isEmailNotificationEnabled
            });
        }

    }

    sortDeliveryFeeMatrix(obj) {

        //sort delivery range in ascending order
        obj.sort((curr, next) => (curr.rangeStart - next.rangeEnd));

        //sort min and max amount in ascending order
        obj.forEach((el, i) => {
            let feeArray = el.feeArray;

            feeArray.sort((curr, next) => (curr.priceStart - next.priceStart || curr.priceEnd - next.priceEnd))
        })

        return obj;
    }

    //edit table-row
    handleEditableRow(index, i) {

        let feeMatrix = this.state.feeMatrix[index];
        let feeArrayMatrix = feeMatrix.feeArray[i];

        let deliveryFeeObjCopy = {};

        deliveryFeeObjCopy["fee"] = feeArrayMatrix.fee;
        deliveryFeeObjCopy["priceStart"] = feeArrayMatrix.priceStart;
        deliveryFeeObjCopy["priceEnd"] = feeArrayMatrix.priceEnd;
        deliveryFeeObjCopy["rangeStart"] = feeMatrix.rangeStart;
        deliveryFeeObjCopy["rangeEnd"] = feeMatrix.rangeEnd;

        let modalTitle = "Edit Delivery Fee";
        let message = "Updated fee setting based on order value!";

        this.setState({
            isEditableRowEnabled: true,
            defaultIndex: index,
            feeIndex: i,
            modalTitle: modalTitle,
            addDeliveryFeeConfig: false,
            deliveryFeeObj: deliveryFeeObjCopy,
            errors: {},
            successMsg: message,
            isDeliveryInfoUpdated: false,
            showZoneModal: true,
            toggleNotifyModal: false,
            addZone: false,
            editDeliveryFeeConfig: false,
            feeTypeActive: false
        });
    }

    //hide modal
    handleCancel(){
        $("body").css('overflow', 'auto');

        this.setState({
            toggleNotifyModal: false,
            showZoneModal: false,
            isBtnDisabled: true,
            deliveryFeeObj:{
                priceStart: "",
                priceEnd:"",
                fee:"",
                rangeStart:"",
                rangeEnd:""
            },
        });
    };

    //hide modal
    closeNotificationModal(){
        $("body").css('overflow', 'auto');
        let activeLocation = this.state.activeLocation;
        let deliveryInfo = _.cloneDeep(activeLocation.deliveryInfo);

        let taxDeliveryFee = false;

        if (deliveryInfo.hasOwnProperty("taxDeliveryFee") && deliveryInfo["taxDeliveryFee"] === true) {
            taxDeliveryFee = true;
        }

        this.setState({
            toggleNotifyModal: false,
            isEmailNotificationEnabled: false,
            taxDeliveryFee,
            showZoneModal: false,
            isBtnDisabled: true,
            fields: deliveryInfo,
        });
    };

    // edit delivery zone
    editDeliveryZone(i){

        let modalTitle = "Edit Delivery Zone";
        // let deliveryFeeObj = this.state.deliveryFeeObj;
        let deliveryFeeObjCopy = {};
        deliveryFeeObjCopy["fee"] = "";

        let feeMatrix = this.state.feeMatrix;
        let deliveryFeeMatrix = feeMatrix[i];
        let itemIndexPos = deliveryFeeMatrix.feeArray.length - 1;
        let feeArrayMatrix = deliveryFeeMatrix.feeArray[itemIndexPos];

        deliveryFeeObjCopy["priceStart"] = feeArrayMatrix.priceStart;
        deliveryFeeObjCopy["priceEnd"] = feeArrayMatrix.priceEnd;
        deliveryFeeObjCopy["fee"] = feeArrayMatrix.fee;
        deliveryFeeObjCopy["rangeStart"] = Utils.convertMetersToMiles(deliveryFeeMatrix.rangeStart);
        deliveryFeeObjCopy["rangeEnd"] = Utils.convertMetersToMiles(deliveryFeeMatrix.rangeEnd);

        let message = "Updated delivery zone!";

        this.setState({
            defaultIndex: i,
            feeIndex: itemIndexPos + 1,
            isEditableRowEnabled: false,
            feeTypeFixed: false,
            addDeliveryFeeConfig: false,
            modalTitle: modalTitle,
            deliveryFeeObj: deliveryFeeObjCopy,
            errors: {},
            isDeliveryInfoUpdated: false,
            editDeliveryFeeConfig: true,
            showZoneModal: true,
            toggleNotifyModal: false,
            addZone: false,
            successMsg: message,
            feeTypeActive: false
        });
    }

    // add config based on delivery fee on same-zone
    addDeliveryFeeConfig(i){
        let modalTitle = "Add Delivery Fee";
        //let deliveryFeeObj = this.state.deliveryFeeObj;
        let deliveryFeeObjCopy = {} ;
        deliveryFeeObjCopy["fee"] = "";

        let feeMatrix = this.state.feeMatrix;
        let deliveryFeeMatrix = feeMatrix[i];
        let itemIndexPos = deliveryFeeMatrix.feeArray.length - 1;
        let feeArrayMatrix = deliveryFeeMatrix.feeArray[itemIndexPos];

        if(feeArrayMatrix.priceEnd >= 9999){
            const msg = "The maximum order amount for this zone is exceeded."
            swal(msg);
            return;
        }

        let message = "Added new fee setting based on order value!";
        deliveryFeeObjCopy["priceStart"] = feeArrayMatrix.priceEnd;

        deliveryFeeObjCopy["priceEnd"] = "";
        deliveryFeeObjCopy["rangeStart"] = "";
        deliveryFeeObjCopy["rangeEnd"] = "";

        this.setState({
            defaultIndex: i,
            feeIndex: itemIndexPos + 1,
            isEditableRowEnabled: false,
            feeTypeFixed: false,
            addDeliveryFeeConfig: true,
            modalTitle: modalTitle,
            deliveryFeeObj: deliveryFeeObjCopy,
            errors: {},
            successMsg: message,
            isDeliveryInfoUpdated: false,
            showZoneModal: true,
            toggleNotifyModal: false,
            editDeliveryFeeConfig: false,
            addZone: false,
            feeTypeActive: false
        });
    }

    // remove the delivery zone/config.
    removeClick(index, i){
        this.setState({ successMsg: "", isDeliveryInfoUpdated: false}, () => {
            this.removeDeliveryConfigUI(index, i);
        })
    }

    addNewZone(){
        let self = this;
        let feeMatrix = this.state.feeMatrix;
        let feeMatrixIndex = 0;

        let modalTitle = "Add New Delivery Zone";

        let deliveryFeeObjCopy = {};

        deliveryFeeObjCopy["fee"] = "";
        deliveryFeeObjCopy["priceStart"] = "";
        deliveryFeeObjCopy["priceEnd"] = "";
        deliveryFeeObjCopy["rangeStart"] = "";
        deliveryFeeObjCopy["rangeEnd"] = "";


        let message = "Added new delivery zone!";

        self.setState({
            isBtnDisabled: true,
            defaultIndex: feeMatrix.length,
            feeTypeFixed: false,
            addDeliveryFeeConfig: false,
            editDeliveryZone: false,
            isEditableRowEnabled: false,
            modalTitle: modalTitle,
            deliveryFeeObj: deliveryFeeObjCopy,
            successMsg: message,
            isDeliveryInfoUpdated: false,
            errors: {},
            editDeliveryFeeConfig: false,
            showZoneModal: true,
            toggleNotifyModal: false,
            addZone: true,
            feeTypeActive: false
        });
    }

    deleteDeliverySettings(index, i) {
        let feeMatrix = this.state.feeMatrix[index];
        let feeMatrixCopy = this.state.feeMatrix;
        let feeArray = feeMatrix.feeArray;
        let lastFeeIndex = feeArray.length - 1;
        let fields = this.state.fields;
        let lastDeliveryZoneIndex = feeMatrixCopy.length - 1;

        // remove delivery config only if single delivery zone
        // and single delivery fee config is present.
        if (feeMatrixCopy.length == 1 && feeArray.length == 1) {

            swal({
                title: "Are you sure?",
                text: "Do you want to delete delivery zone?",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            }).then((willDelete) => {
                if (willDelete) {
                    let message = "Deleted delivery zone!";
                    fields["feeMatrix"] = [];

                    this.setState({
                        fields: fields,
                        feeMatrix: [],
                        successMsg: message,
                    }, () => {
                        this.updateDeliveryInfoData();
                    })

                }
            });

            return;
        }
    }

    deleteDeliveryZone(index, i) {
        let feeMatrix = this.state.feeMatrix[index];
        let feeMatrixCopy = this.state.feeMatrix;
        let feeArray = feeMatrix.feeArray;
        let lastFeeIndex = feeArray.length - 1;
        let fields = this.state.fields;
        let lastDeliveryZoneIndex = feeMatrixCopy.length - 1;

        // remove delivery zone only when single delivery fee is configured.
        if (feeMatrixCopy.length > 1) {

            let adjustDeliveryRange = false;

            if (lastDeliveryZoneIndex > index) {
                var rangeMsg = "Warning: Deleting this will result in an automatic adjustment of other zones.";
                adjustDeliveryRange = true;
            } else {
                var rangeMsg = "Do you want to delete delivery zone?";
                adjustDeliveryRange = false;
            }


            swal({
                title: "Are you sure?",
                text: rangeMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
                reverseButtons: true
            }).then((willDelete) => {
                if (willDelete) {

                    let message = "Deleted delivery zone!";

                    feeMatrixCopy = [...feeMatrixCopy];
                    feeMatrixCopy.splice(index, 1);
                    fields["feeMatrix"] = feeMatrixCopy;

                    this.setState({
                        feeMatrix: feeMatrixCopy,
                        fields: fields,
                        successMsg: message
                    }, () => {
                        this.adjustDeliveryZoneOverLapValue(adjustDeliveryRange, index);
                    });
                }
            });

            return;
        }
    }

    adjustDeliveryZoneOverLapValue(adjustDeliveryRange, index) {

        let feeMatrixCopy = this.state.feeMatrix;

        this.setMinAmount();

        if (adjustDeliveryRange) {
            let currentDeliveryRange = feeMatrixCopy[index];
            let prevDeliveryRange = feeMatrixCopy[index];

            if (index == 0) {
                let currentDeliveryRange = feeMatrixCopy[index];
                currentDeliveryRange.rangeStart = 0;
            } else {
                let currentDeliveryRange = feeMatrixCopy[index];
                let prevDeliveryRange = feeMatrixCopy[index - 1];
                currentDeliveryRange.rangeStart = prevDeliveryRange.rangeEnd;
            }

        }

        this.updateDeliveryInfoData();
    }

    deleteDeliveryFee(index, i) {
        let feeMatrix = this.state.feeMatrix[index];
        let feeMatrixCopy = this.state.feeMatrix;
        let feeArray = feeMatrix.feeArray;
        let lastFeeIndex = feeArray.length - 1;
        let fields = this.state.fields;
        let lastDeliveryZoneIndex = feeMatrixCopy.length - 1;

        // remove delivery fee config based on order value
        if (feeArray.length > 1) {

            let adjustDeliveryFeeConfig = false;

            if (feeArray.length - 1 > i && i > 0) {
                var textMsg = "Warning: Deleting this will result in an automatic adjustment of other fee settings.";
                adjustDeliveryFeeConfig = true;
            } else {
                var textMsg = "Do you want to delete fee setting?";
                adjustDeliveryFeeConfig = false;
            }

            swal({
                title: "Are you sure?",
                text: textMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {

                    let message = "Deleted fee setting based on order value!";
                    let feeArray = [...feeMatrix.feeArray];

                    feeArray.splice(i, 1);
                    feeMatrix["feeArray"] = feeArray;
                    fields["feeMatrix"] = feeMatrixCopy;

                    this.setState({
                        feeMatrix: feeMatrixCopy,
                        fields: fields,
                        successMsg: message
                    }, () => {
                        this.adjustDeliveryFeeOverLapValue(adjustDeliveryFeeConfig, index, i);
                    });
                }
            });

            return;
        }
    }


    adjustDeliveryFeeOverLapValue(adjustDeliveryFeeConfig, index, i) {

        let feeMatrix = this.state.feeMatrix[index];

        //set minAmount;
        this.setMinAmount();

        if (adjustDeliveryFeeConfig) {
            let currentFeePrice = feeMatrix.feeArray[i];
            let prevFeePrice = feeMatrix.feeArray[i - 1];
            currentFeePrice.priceStart = prevFeePrice.priceEnd;
        }

        this.updateDeliveryInfoData();
    }

    async removeDeliveryConfigUI(index, i) {
        let feeMatrix = this.state.feeMatrix[index];
        let feeMatrixCopy = this.state.feeMatrix;
        let feeArray = feeMatrix.feeArray;
        let lastFeeIndex = feeArray.length - 1;
        let fields = this.state.fields;
        let lastDeliveryZoneIndex = feeMatrixCopy.length - 1;

        // First check the FeeMatrixCopy array - do we need to delete complete object or not
        if (feeMatrixCopy.length == 1 && feeArray.length == 1) {
            // delete complete delivery info object
            this.deleteDeliverySettings(index, i);

        } else if (feeMatrixCopy.length > 1 && feeArray.length == 1) {
            // delete delivery zone
            this.deleteDeliveryZone(index, i);

        } else if (feeArray.length > 1) {
            // delete delivery fee based on order value
            this.deleteDeliveryFee(index, i);
        }
    }

    // handle the input field change
    handleChange(field, e) {
        let self = this;
        let value = e.target.value;
        let feeMatrix = this.state.feeMatrix;
        let fields = this.state.fields;

        let orderPriceEnd = "";
        let deliveryRangeValue = "";
        let deliveryFeeValue = "";

        if(!Utils.isEmpty(value)){
            orderPriceEnd = parseFloat(value.replace(/(\.\d{2})\d+/g, '$1'));
            deliveryRangeValue = parseFloat(value.replace(/(\.\d{1})\d+/g, '$1'));
            deliveryFeeValue = parseFloat(value.replace(/(\.\d{2})\d+/g, '$1'));
        }

        let deliveryFeeObj = this.state.deliveryFeeObj;

        if (field == "rangeStart") {
            deliveryFeeObj.rangeStart = deliveryRangeValue;
        }

        if (field == "rangeEnd") {
            deliveryFeeObj.rangeEnd = deliveryRangeValue;
        }

        if(field == "priceStart"){
            deliveryFeeObj.priceStart = orderPriceEnd;
        }
        //
        if(field == "priceEnd"){
            deliveryFeeObj.priceEnd  = orderPriceEnd ;
        }

        if(field == "fee"){
            deliveryFeeObj.fee  = deliveryFeeValue;
        }

        if(field == "notifyEmail"){
            fields.notifyEmail  = value;
        }

        self.setState({
            errors: {},
            isBtnDisabled:false,
        });

    }

    //remove alert box
    handleAlert(){
        this.setState({
            isDeliveryInfoUpdated: false,
            successMsg: ""
        });
    }

    //handle the input change in delivery fee type
    handleFeeTypeChange(field, e){

        let fields = this.state.fields;
        var value = e.target.value;
        let feeMatrix = this.state.feeMatrix;

        // let message = "updated delivery fee type!"

        fields[field] = value;

        this.setState({
            fields: fields,
            errors: {},
            isBtnDisabled: false,
            successMsg: "",
            isDeliveryInfoUpdated: false,
            feeTypeActive: true
        }, () => {
            // It will call only when we have data on server
            if (feeMatrix.length > 0) {
                // this.updateDeliveryInfoData();
            }
        });
    }

    handleTaxOnDeliveryFee(field, e) {
        let fields = this.state.fields;
        var value = e.target.value;
        let feeMatrix = this.state.feeMatrix;

        let taxOnDeliveryFee = false;
        // let message = "disabled tax on delivery fee!"

        if (value == "true") {
            // message = "enabled tax on delivery fee!"
            taxOnDeliveryFee = true;
        }

        fields[field] = taxOnDeliveryFee;

        this.setState({
            fields: fields,
            errors: {},
            isBtnDisabled: false,
            successMsg: "",
            isDeliveryInfoUpdated: false,
            feeTypeActive: true,
            taxDeliveryFee: taxOnDeliveryFee,
        }, () => {
            if (feeMatrix.length > 0) {
                // this.updateDeliveryInfoData();
            }
        });
    }

    validateDeliveryRangeFields() {

        let errors = {};
        let formIsValid = true;
        let feeMatrix = this.state.feeMatrix;
        let feeMatrixLength = feeMatrix.length;
        let defaultIndex = this.state.defaultIndex;
        let deliveryFeeObj = this.state.deliveryFeeObj;
        let prevFeeMatrixArray = feeMatrix[defaultIndex - 1];
        let rangeEnd = Utils.convertMilesToMeters(deliveryFeeObj.rangeEnd);

        //validate current delivery zone is greater than previous delivery zone
        if(feeMatrixLength > 0 ){

            if( this.state.addZone == true && prevFeeMatrixArray.rangeEnd >= rangeEnd){
                formIsValid = false;
                errors["rangeEnd"] = `Radius should be greater than previous delivery zone.`;
                this.setState({ errors });
                return formIsValid;
            }
        }

        //validate for empty maximum delivery range.
        if(!this.state.addDeliveryFeeConfig && Utils.isEmpty(rangeEnd)){
            formIsValid = false;
            errors["rangeEnd"] = "Radius cannot be left empty.";
            this.setState({errors: errors });
            return formIsValid;
        }

        return formIsValid;
    }

    validateAddNewZoneFields(){
        let self = this;
        let formIsValid = true;

        if( !self.validateDeliveryRangeFields()){
            formIsValid = false;
            return formIsValid;
        }

        if(!self.validateFeeArrayFields()){
            formIsValid = false;
            return formIsValid;
        }

        return formIsValid;

    }

    async validateDeliveryZoneOverlap(){

        let formIsValid = true;
        this.setState({allowZoneOverLap: false})
        let feeMatrix = this.state.feeMatrix;
        let defaultIndex = this.state.defaultIndex;
        let deliveryFeeObj = this.state.deliveryFeeObj;
        let feeMatrixLastElem = feeMatrix.length - 1;
        let prevDeliveryRange = feeMatrix[defaultIndex - 1];
        let currentDeliveryRange = feeMatrix[defaultIndex];
        let nextDeliveryRange = feeMatrix[defaultIndex + 1];
        let rangeEnd = Utils.convertMilesToMeters(deliveryFeeObj.rangeEnd);
        let rangeStart = Utils.convertMilesToMeters(deliveryFeeObj.rangeStart);
        const alertMsg = "Warning: Delivery radius is overlapping. Affected delivery zones will be updated automatically.";

        let prevDeliveryRadiusOverLap = false;
        let nextDeliveryRadiusOverLap = false;
        //
        if (defaultIndex > 0) {

            if (prevDeliveryRange.rangeEnd > rangeStart || prevDeliveryRange.rangeEnd < rangeStart) {
                prevDeliveryRadiusOverLap = true;
            }
        }

        if(feeMatrixLastElem > defaultIndex ) {
            if(nextDeliveryRange.rangeStart < rangeEnd || nextDeliveryRange.rangeStart > rangeEnd){
                nextDeliveryRadiusOverLap = true;
            }
        }

        if(prevDeliveryRadiusOverLap && nextDeliveryRadiusOverLap){
            this.setState({ showZoneModal : false })

            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                prevDeliveryRange.rangeEnd = rangeStart;
                nextDeliveryRange.rangeStart = rangeEnd;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;

        }

        if(prevDeliveryRadiusOverLap){
            this.setState({ showZoneModal : false })

            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                prevDeliveryRange.rangeEnd = rangeStart;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;
        }

        if(nextDeliveryRadiusOverLap){
            this.setState({ showZoneModal : false })
            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                nextDeliveryRange.rangeStart = rangeEnd;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;

        }

        return formIsValid;

    }

    async validateDeliveryZone(){
        let self = this;
        let errors = {};
        let formIsValid = true;
        let feeMatrix = this.state.feeMatrix;
        let defaultIndex = this.state.defaultIndex;
        let deliveryFeeObj = this.state.deliveryFeeObj;
        let deliveryRangeStart = deliveryFeeObj.rangeStart;
        let feeMatrixLastElem = feeMatrix.length - 1;
        let prevDeliveryRange = feeMatrix[defaultIndex - 1];
        let currentDeliveryRange = feeMatrix[defaultIndex];
        let nextDeliveryRange = feeMatrix[defaultIndex + 1];
        let lastDeliveryRange = feeMatrix[feeMatrixLastElem];
        let rangeEnd = Utils.convertMilesToMeters(deliveryFeeObj.rangeEnd);
        let rangeStart = Utils.convertMilesToMeters(deliveryFeeObj.rangeStart);

        //validate for delivery minimum radius
        if (Utils.isEmpty(deliveryRangeStart) && deliveryRangeStart !== 0) {
            formIsValid = false;
            errors["rangeStart"] = "Radius cannot be left empty.";
            this.setState({errors});
            return formIsValid;

        }

        if (!self.validateDeliveryRangeFields()) {
            formIsValid = false;
            return formIsValid;
        }

        //validate current delivery start range is less than current delivery end range
        if (rangeStart >= currentDeliveryRange.rangeEnd) {
            formIsValid = false;
            errors["rangeStart"] = `Radius should be less than ${Utils.convertMetersToMiles(currentDeliveryRange.rangeEnd)} miles.`;
            this.setState({errors});
            return formIsValid;
        }

        //validate current delivery start range is less than current delivery end range
        if(rangeStart >= rangeEnd) {
            formIsValid = false;
            errors["rangeEnd"] = `Radius should be greater than ${Utils.convertMetersToMiles(rangeStart)} miles.`;
            this.setState({errors});
            return formIsValid;
        }

        //validate current delivery range is greater than prevous delivery range
        if(defaultIndex > 0 && rangeStart <= prevDeliveryRange.rangeStart) {
            formIsValid = false;
            errors["rangeStart"] = `Radius should be greater than ${Utils.convertMetersToMiles(prevDeliveryRange.rangeStart)} miles.`;
            this.setState({errors});
            return formIsValid;
        }

        //validate current delivery range is less than next delivery range
        if(feeMatrixLastElem > defaultIndex  && nextDeliveryRange.rangeEnd <= rangeEnd) {
            formIsValid = false;
            errors["rangeEnd"] = `Radius should be less than ${Utils.convertMetersToMiles(nextDeliveryRange.rangeEnd)} miles.`;
            this.setState({errors});
            return formIsValid;
        }

        //validate current delivery range is less than next delivery range
        if(feeMatrixLastElem > defaultIndex && lastDeliveryRange.rangeEnd <= rangeEnd) {
            formIsValid = false;
            errors["rangeEnd"] = `Radius  should be less than ${Utils.convertMetersToMiles(lastDeliveryRange.rangeEnd)}   miles.`;
            this.setState({errors});
            return formIsValid;
        }

        const validateDeliveryZoneOverlap = await self.validateDeliveryZoneOverlap();

        if(!validateDeliveryZoneOverlap){
            formIsValid =  false;
            return formIsValid;
        }

        return formIsValid;
    }

    async validateOrderAmountOverlap(){

        let formIsValid = true;
        let feeMatrix = this.state.feeMatrix;
        let defaultIndex = this.state.defaultIndex;
        let deliveryFeeMatrix = feeMatrix[defaultIndex];
        let deliveryFeeObj = this.state.deliveryFeeObj;
        let itemLength = deliveryFeeMatrix.feeArray.length;
        let itemIndexPos = this.state.feeIndex;
        let currentFeeArray = deliveryFeeMatrix.feeArray[itemIndexPos];
        let prevFeeArray = deliveryFeeMatrix.feeArray[itemIndexPos - 1];
        let nextFeeArray = deliveryFeeMatrix.feeArray[itemIndexPos + 1];
        let alertMsg = "Warning: Order amount is overlapping, Affected fee settings will be adjusted automatically.";

        let prevZoneOverLap = false;
        let nextZoneOverLap = false;

        if(itemIndexPos > 0){

            if(prevFeeArray.priceEnd  > deliveryFeeObj.priceStart || prevFeeArray.priceEnd < deliveryFeeObj.priceStart) {
                prevZoneOverLap = true;
            }
        }

        if(itemLength - 1 > itemIndexPos ) {
            if(nextFeeArray.priceStart < deliveryFeeObj.priceEnd || nextFeeArray.priceStart > deliveryFeeObj.priceEnd){
                nextZoneOverLap = true;
            }
        }


        if(prevZoneOverLap && nextZoneOverLap){
            this.setState({ showZoneModal : false })

            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                prevFeeArray.priceEnd = deliveryFeeObj.priceStart;
                nextFeeArray.priceStart = deliveryFeeObj.priceEnd;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;

        }

        if(prevZoneOverLap){
            this.setState({ showZoneModal : false })

            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                prevFeeArray.priceEnd = deliveryFeeObj.priceStart;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;
        }

        if(nextZoneOverLap){
            this.setState({ showZoneModal : false })
            const confirm = await swal({
                title: "Are you sure?",
                text: alertMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })

            if(confirm){
                nextFeeArray.priceStart = deliveryFeeObj.priceEnd;
                formIsValid = true;
            }else{
                formIsValid = false;
                this.setState({ showZoneModal : true })
            }

            return formIsValid;

        }

        return formIsValid
    }

    async validateEditTableRowValues(){
        let self = this;
        let formIsValid = true;
        let errors = {};
        let feeMatrix = this.state.feeMatrix;
        let defaultIndex = this.state.defaultIndex;
        let deliveryFeeMatrix = feeMatrix[defaultIndex];
        let deliveryFeeObj = this.state.deliveryFeeObj;
        let itemLength = deliveryFeeMatrix.feeArray.length;
        let itemIndexPos = this.state.feeIndex;
        let prevFeeArray = deliveryFeeMatrix.feeArray[itemIndexPos - 1];
        let nextFeeArray = deliveryFeeMatrix.feeArray[itemIndexPos + 1];

        if(itemIndexPos > 0 && deliveryFeeObj.priceStart <= prevFeeArray.priceStart){
            formIsValid = false;
            errors["minAmount"] = `Value should be greater than $${prevFeeArray.priceStart}`;
            this.setState({ errors });
            return formIsValid;
        }

        if(itemIndexPos > 0 && deliveryFeeObj.priceEnd <= prevFeeArray.priceEnd){
            formIsValid = false;
            errors["maxAmount"] = `Value should be greater than $${prevFeeArray.priceEnd}`;
            this.setState({ errors });
            return formIsValid;
        }

        if(itemLength - 1 > itemIndexPos && deliveryFeeObj.priceStart >= nextFeeArray.priceStart){
            formIsValid = false;
            errors["minAmount"] = `Value should be less than $${nextFeeArray.priceStart}`;
            this.setState({ errors });
            return formIsValid;
        }

        if(itemLength - 1 > itemIndexPos && deliveryFeeObj.priceEnd >= nextFeeArray.priceEnd){
            formIsValid = false;
            errors["maxAmount"] = `Value Value should be less than $${nextFeeArray.priceEnd}`;
            this.setState({ errors });
            return formIsValid;
        }

        if(!self.validateFeeArrayFields()){
            formIsValid = false;
            return formIsValid;
        }

        const validateOrderAmountOverlap = await self.validateOrderAmountOverlap();

        if(!validateOrderAmountOverlap){
            formIsValid =  false;
            return formIsValid;
        }

        return formIsValid;

    }

    validateFeeArrayFields(){
        let self = this;
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        const defaultIndex = this.state.defaultIndex;
        const itemIndexPos = this.state.feeIndex;
        let deliveryFeeObj = this.state.deliveryFeeObj;
        const matrix   = this.state.feeMatrix;

        let minAmount = "";

        if(fields.hasOwnProperty("minAmount")){
            minAmount =  fields.minAmount;
        }

        // validate if min order amount is not empty
        if(Utils.isEmpty(deliveryFeeObj.priceStart) && deliveryFeeObj.priceStart !== 0){
            formIsValid = false;
            errors["minAmount"] = "Value cannot be left empty.";
            this.setState({ errors });
            return formIsValid;
        }

        let priceStart = deliveryFeeObj.priceStart;

        if(this.state.isEditableRowEnabled){
            const currentFeeMatrix = matrix[defaultIndex];
            const currentFeeArray = currentFeeMatrix.feeArray[itemIndexPos];
            priceStart = currentFeeArray.priceStart;
        }
        //validate max delivery amount is not greater than $9999.
        if(deliveryFeeObj.priceStart >= 9999){
            formIsValid = false;
            errors["minAmount"] = `Value should be less than $9999`;
            this.setState({ errors });
            return formIsValid;
        }

        //validate max delivery amount is not greater than $9999.
        if(deliveryFeeObj.priceEnd > 9999){
            formIsValid = false;
            errors["maxAmount"] = `Value should not exceed $9999`;
            this.setState({ errors });
            return formIsValid;
        }

        //validate max delivery amount is not empty.
        if(Utils.isEmpty(deliveryFeeObj.priceEnd) && deliveryFeeObj.priceEnd !== 0){
            formIsValid = false;
            errors["maxAmount"] = "Value cannot be left empty.";
            this.setState({ errors });
            return formIsValid;
        }

        //minimum order amount should be greater than minAmount.
        if(minAmount > priceStart){
            formIsValid = false;
            errors["minAmount"] = `Value must be over and above $${minAmount}`;
            this.setState({ errors });
            return formIsValid;
        }

        // validate delivery amount is less than max delivery amount.
        if( deliveryFeeObj.priceEnd <= deliveryFeeObj.priceStart){
            formIsValid = false;
            errors["maxAmount"] = `Value should be greater than $${deliveryFeeObj.priceStart}`;
            this.setState({ errors });
            return formIsValid;
        }

        //validate for empty delivery fee
        if( Utils.isEmpty(deliveryFeeObj.fee) && deliveryFeeObj.fee !== 0 ){
            formIsValid = false;
            errors["deliveryFee"] = "Fee cannot be left empty.";
            this.setState({ errors });
            return formIsValid;
        }

        return formIsValid;
    }

    async handleValidation() {

        let self = this;
        let isFormValid = true;
        let fields = this.state.fields;
        let errors = {};

        //validate when new zone is added
        if (self.state.addZone && !self.validateAddNewZoneFields()) {
            isFormValid = false
            return isFormValid;
        }

        //validate when new delivery fee config is added based on order value
        if (self.state.addDeliveryFeeConfig && !self.validateFeeArrayFields()) {
            isFormValid = false
            return isFormValid;
        }


        // validate when delivery range values are edited
        if (self.state.editDeliveryFeeConfig) {
            let validateDeliveryZone = await self.validateDeliveryZone();

            if (!validateDeliveryZone) {
                return validateDeliveryZone;
            }

        }


        // validate when table-row values are edited
        if (self.state.isEditableRowEnabled){
            let validateEditTableRowValues = await self.validateEditTableRowValues();

            if (!validateEditTableRowValues) {
                return validateEditTableRowValues;
            }
        }

        return true;

    }


    //Asynchronously validates the notification email.
    async validateNotificationEmail() {

        let self = this;
        let isFormValid = true;
        let errors = {};

        // Validate notify email
        if (this.state.isEmailNotificationEnabled) {
            const fields = this.state.fields;

            if (Utils.isEmpty(fields["notifyEmail"])) {
                isFormValid = false;
                errors["notifyEmail"] = `Email is required.`;
            }
            else if(!Utils.isEmpty(fields["notifyEmail"]) && !EMAIL_REGEX.test(fields["notifyEmail"])) {
                isFormValid = false;
                errors["notifyEmail"] = `Invalid email address. Special characters are not allowed.`;
            }

        }

        this.setState({ errors });
        return isFormValid;
    }

    // Handles the submission of the notification email form.
    async submitNotifyEmailForm(e){
        e.preventDefault();

        let validation = await this.validateNotificationEmail();

        if(validation){
            let self = this;
            let fields = { ...this.state.fields }; // Create a shallow copy of the fields object
            let deliveryFeeObj = this.state.deliveryFeeObj;
            const { isEmailNotificationEnabled } = this.state;

            if (!isEmailNotificationEnabled) {
                delete fields.notifyEmail; // Remove the notifyEmail property if isEmailNotificationEnabled is false
            }

            self.setState( { fields:fields , toggleNotifyModal: false }, () => {
                self.updateDeliveryInfoInDatabase();
            })
        }

    }


    async updateDeliveryFormSubmit(e) {
        e.preventDefault();

        let validation = await this.handleValidation();

        if(validation){
            let self = this;
            let fields = this.state.fields;
            let feeMatrix = this.state.feeMatrix;
            let coordinatesConfig = this.state.coordinates;
            let defaultIndex = this.state.defaultIndex;
            let feeIndex = this.state.feeIndex;
            let currentFeeMatrix = feeMatrix[defaultIndex]

            let deliveryFeeObj = this.state.deliveryFeeObj;

            //convert delivery range values in meters
            deliveryFeeObj.rangeEnd = Utils.convertMilesToMeters(deliveryFeeObj.rangeEnd);
            deliveryFeeObj.rangeStart = Utils.convertMilesToMeters(deliveryFeeObj.rangeStart);

            if (!fields.hasOwnProperty("feeType")) {
                fields["feeType"] = "fixed";
            }

            if (!fields.hasOwnProperty("taxDeliveryFee")) {
                fields["taxDeliveryFee"] = true;
            }

            let deliveryFeeObjCopy = {};

            if (!Utils.isEmptyObj(deliveryFeeObj)) {
                deliveryFeeObjCopy["fee"] = deliveryFeeObj.fee;
                deliveryFeeObjCopy["priceStart"] = deliveryFeeObj.priceStart;
                deliveryFeeObjCopy["priceEnd"] = deliveryFeeObj.priceEnd;
            }

            //add new delivery fee config
            if(this.state.addDeliveryFeeConfig){
                //when split price config is added;
                let feeArrayCopy = currentFeeMatrix.feeArray;

                let itemIndex = feeArrayCopy.length;
                //add split order fee config on last index.
                feeArrayCopy.splice(itemIndex, 0 , deliveryFeeObjCopy);
            }

            //Edit split delivery fee
            if(this.state.isEditableRowEnabled){
                let feeArrayDuplicate  = currentFeeMatrix.feeArray;

                //add split order fee config on last index.
                feeArrayDuplicate.splice(feeIndex, 1 , deliveryFeeObjCopy);
            }

            // add new zone
            if(this.state.addZone){
                let prevFeeMatrix = feeMatrix[defaultIndex-1];
                let feeMatrixObj = {};
                feeMatrixObj["feeArray"] = [deliveryFeeObjCopy];

                feeMatrixObj["rangeStart"] = deliveryFeeObj.rangeStart;

                //set first min delivery radius zero in case
                //no other zone is present
                if(defaultIndex > 0){
                    feeMatrixObj["rangeStart"] = prevFeeMatrix.rangeEnd;
                }

                feeMatrixObj.rangeEnd = deliveryFeeObj.rangeEnd;
                feeMatrix.push(feeMatrixObj);

            }

            //edit Zone
            if(this.state.editDeliveryFeeConfig){
                currentFeeMatrix.rangeStart = deliveryFeeObj.rangeStart;
                currentFeeMatrix.rangeEnd = deliveryFeeObj.rangeEnd;
            }

            fields["feeMatrix"] = feeMatrix;

            if(deliveryFeeObj.hasOwnProperty("notifyEmail") && !Utils.isEmpty(deliveryFeeObj["notifyEmail"])){
                fields["notifyEmail"] = deliveryFeeObj.notifyEmail;
            }

            //if coordinates config is present
            //then set coordinates key and value in fields object.
            if(coordinatesConfig.length > 0){
                fields["coordinates"] = coordinatesConfig;
            }

            //set minAmount
            self.setMinAmount();

            self.setState( { feeMatrix:feeMatrix , fields:fields , showZoneModal: false }, () => {
                self.updateDeliveryInfoData();
            })

        }
    };

    validateFieldsValues(){
        let arrFeeStart = [];
        let arrFeeEnd = [];
        let errors = {}
        let isFormValid = true;
        let feeMatrix = this.state.feeMatrix;
        let fields = this.state.fields;

        feeMatrix.every((el, index) => {
            let nextFeeMatrix = feeMatrix[index + 1];
            let feeMatrixLastIndex = feeMatrix.length - 1;
            let feeArray = el.feeArray;
            let rangeStart = Utils.convertMetersToMiles(el.rangeStart);
            let rangeEnd = Utils.convertMetersToMiles(el.rangeEnd);

            // check gap in delivery zones
            if (index !== feeMatrixLastIndex) {
                let nextRangeStart = Utils.convertMetersToMiles(nextFeeMatrix.rangeStart);

                //check for overlapping zones.
                if (nextRangeStart < rangeEnd) {
                    let msg = "Warning: Delivery radius is overlapping, delivery settings will be refreshed automatically.";

                    swal(msg).then((value) => {
                        this.setState({
                            defaultIndex: index,
                            isDeliveryInfoUpdated: false,
                            successMsg: ""
                        }, () => {
                            this.props.reloadLocation();
                        });
                    })

                    isFormValid = false;
                    return isFormValid;
                }


                //check for gap in delivery radius
                if(nextRangeStart > rangeEnd){
                    let msg = "Warning: A gap is found in delivery radius, delivery settings will be refreshed automatically.";

                    swal(msg).then((value) => {
                        this.setState({ defaultIndex: index , isDeliveryInfoUpdated: false, successMsg: ""}, ()=> {
                            this.props.reloadLocation();
                        });
                    })

                    isFormValid = false;
                    return isFormValid;
                }


            }

            arrFeeStart.push(rangeStart)
            arrFeeEnd.push(rangeEnd)

            return isFormValid;

        })

        if(!isFormValid){
            return;
        }

        // comparing each element of fee matrix delivery range
        for (let i = 0; i < arrFeeStart.length; i++) {
            if (arrFeeStart[i] >= arrFeeEnd[i]) {

                let msg = "Warning: Wrong config set, delivery settings will be refreshed automatically.";

                swal(msg).then((value) => {
                    this.setState({  isDeliveryInfoUpdated: false, successMsg: ""}, ()=> {
                        this.props.reloadLocation();
                    });
                })

                isFormValid = false;
                return isFormValid;
            }
        }

        return isFormValid;
    }


    //update deliveryInfo to database
    updateDeliveryInfoData(){
        let self = this;

        if(!self.validateFieldsValues()){
            return;
        }

        self.updateDeliveryInfoInDatabase();
    }

    updateDeliveryInfoInDatabase(){
        let self = this;
        //show loading spinner
        this.props.showSpinner(false);
        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;
        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;
        let fields = this.state.fields;
        let feeMatrix = this.state.feeMatrix;

        let paramsObject = {};
        paramsObject["objectId"] = locId;
        paramsObject["deliveryInfo"] = fields;

        //remove delivery config
        if(feeMatrix.length == 0){
            paramsObject["deliveryInfo"] = {"__op" : "Delete"};
        }

        // this.setState({ isLoaded: false});
        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    self.setState({
                        isBtnDisabled: true,
                        toggleNotifyModal: false,
                        showSuccessMsg:"",
                        isDeliveryInfoUpdated: true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                    // remove alert after 5 seconds.
                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

                    this.setState({
                        isDeliveryInfoUpdated: false,
                        toggleNotifyModal: false,
                        showSuccessMsg:"",
                    });
                }
            );
    }

    renderFeeType(){
        let fields = this.state.fields;
        let selectedFeeType = " Dollar Value ";

        if(!Utils.isEmptyObj(fields) && fields.hasOwnProperty("feeType")){
            let feeType = fields.feeType;

            if(feeType == "fixed"){
                selectedFeeType = " Dollar Value ";
            }

            if(feeType == "percentage"){
                selectedFeeType = " Percentage of Subtotal "
            }
        }

        return selectedFeeType;

    }

    renderDeliveryConfigRow(element, index){
        let fields = this.state.fields;

        return element.map ((el, i) => (
            <tr key={i} className={"editable"}>
                <td>
                    ${el.priceStart}
                </td>
                <td>
                    ${el.priceEnd}
                </td>

                <td>
                    {
                        !Utils.isEmptyObj(fields) && fields.hasOwnProperty("feeType") ? (
                            fields.feeType == "fixed" ? `$${el.fee}` : `${el.fee}%`
                        ) : `$${el.fee}`
                    }

                </td>

                <td>
                    <span style={{display: "inline-flex"}}>
                         <a href="JavaScript:void(0);" onClick={this.handleEditableRow.bind(this,index, i)}>
                            <i className={"fa fa-edit fa-lg text-dark"}></i>
                        </a>


                        <a href="JavaScript:void(0);" onClick={this.removeClick.bind(this, index, i)}>
                            <i className={"fa fa-trash ml-10 fa-lg text-dark"}></i>
                        </a>
                    </span>

                </td>

            </tr>
        ))
    }


    renderDeliveryFeeRow(){

        let activeLocation = this.state.activeLocation;

        let deliveryInfoArr = [];

        if(!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(activeLocation.deliveryInfo)){
            let deliveryInfo = activeLocation.deliveryInfo;
            const matrix = "feeMatrix";

            if(deliveryInfo.hasOwnProperty(matrix)){
                deliveryInfoArr = this.sortDeliveryFeeMatrix(deliveryInfo.feeMatrix);
            }
        }

        if(deliveryInfoArr.length >  0){
            return deliveryInfoArr.map((element, index) => (

                    <div className="col-lg-12 mt-20" key={index} >
                        <div className="col-lg-12 table-responsive deliveryfee-table-container no-gutter" style={{border: "none"}}>

                            <div>

                                    <span style={{padding: "4px 10px 0 0"}}>
                                        <span><b>Delivery Zone: <span style={{fontSize: "15px"}}>
                                                <span>
                                                    {Utils.convertMetersToMiles(element.rangeStart)} - {Utils.convertMetersToMiles(element.rangeEnd)} Miles
                                                </span>
                                            </span>
                                        </b></span>
                                    </span>

                                <span style={{padding: "10px 14px 5px 8px", borderLeft: "2px solid #DFDFDF" }} >
                                        <span className="ml-5">
                                          <a href="JavaScript:void(0);"  onClick={this.addDeliveryFeeConfig.bind(this, index)}>Set fee based on order value</a>
                                        </span>
                                    </span>

                                <span style={{padding: "10px 4px 5px 8px", borderLeft: "2px solid #DFDFDF" }} >
                                        <span className="ml-5">
                                          <a href="JavaScript:void(0);"  onClick={this.editDeliveryZone.bind(this, index)}>Edit delivery zone</a>
                                        </span>
                                    </span>
                            </div>

                            <table id={index} className="mt-10 delivery-table table table-striped" style={{border: "1px solid #ddd", textAlign: "center"}}>
                                <tbody>
                                <tr>
                                    <th scope="col" className="table-col" style={{textAlign: "center"}}><b>Minimum Amount</b></th>
                                    <th scope="col" className="table-col" style={{textAlign: "center"}}><b>Maximum Amount</b></th>
                                    <th scope="col" className="table-col" style={{textAlign: "center"}}><b>Delivery Fee</b></th>
                                    <th scope="col" className="table-col" style={{textAlign: "center"}}><b>Edit</b></th>

                                </tr>

                                {
                                    this.renderDeliveryConfigRow(element.feeArray, index)
                                }

                                </tbody>
                            </table>

                        </div>
                    </div>
                )

            )

        }

    }

    showSuccessMsg(){
        swal(`${this.state.isEmailNotificationEnabled ? "Successfully" : ""} ${this.state.successMsg}`, {
            icon: "success",
        }).then((value) => {
            this.setState({
                isDeliveryInfoUpdated: false,
                successMsg: ""
            });
        })
    }

    handleChangeToggle = (event) => {
        const { value }  = event.target;
        const { fields } = this.state;
        let feeMatrix    = this.state.feeMatrix;

        let message = "Add Delivery Settings";
        let isEmailNotificationEnabled = false;

        if (value === "true") {
            isEmailNotificationEnabled = true;
        }

        this.setState({
            isEmailNotificationEnabled,
            modalTitle: message,
            addDeliveryFeeConfig: !isEmailNotificationEnabled,
            isEditableRowEnabled: !isEmailNotificationEnabled,
            editDeliveryFeeConfig: !isEmailNotificationEnabled,
            addZone: !isEmailNotificationEnabled,
            errors: {}
        });
    }

    async handleNotifyEmail() {
        const { fields } = this.state;
        let activeLocation = this.state.activeLocation;
        // Deep Clone of Delivery Info Object to update the value in local
        let deliveryInfoConfig = _.cloneDeep(activeLocation.deliveryInfo);

        let isEmailNotificationEnabled = false;

        if( deliveryInfoConfig.hasOwnProperty("notifyEmail") && !Utils.isEmpty(deliveryInfoConfig.notifyEmail)){
            isEmailNotificationEnabled = true;
        }

        this.setState({
            toggleNotifyModal: true,
            isEmailNotificationEnabled,
            modalTitle: "Add Delivery Settings",
            errors: {}
        });
    }

    renderComponentWhenNotifyEmailDisabled(){
        return(
            <span className="text-muted ft-14">
                Do you want to choose our nation-wide nationwide delivery service through DoorDash Drive for your delivery orders? <br />

                <span className="mt-10 d-block">
                    Get in touch with <a href="mailto:support@freshbytes.io">Freshbytes</a> at "support@freshbytes.io" to set up DoorDash Drive today
                </span>

            </span>
        );
    }

    renderNotifyEmailForm() {

        let fields = this.state.fields;

        let isFeeTypeFixed = true;

        if (!Utils.isEmptyObj(fields) && fields.hasOwnProperty("feeType")) {

            if (fields["feeType"] == 'fixed') {
                isFeeTypeFixed = true;
            } else {
                isFeeTypeFixed = false;
            }

        }

        return (
            <form name="updateLocationForm" onSubmit={this.submitNotifyEmailForm.bind(this)}>
                <div className={"row"}>
                    <div className="container" style={{
                        maxWidth: '100%',
                        padding: "0 20px 15px 20px"
                    }}>
                        <div className="col-sm-12">

                            <div className="page-header mb-5">
                                            <span className={"deliverFeeType-radio"}>
                                                <b>Delivery fee type: </b><a
                                                href="JavaScript:void(0);"></a>
                                            </span>

                                <span className={"deliveryfeetype-span"} style={{marginLeft: "5px"}}
                                      onChange={this.handleFeeTypeChange.bind(this, "feeType")}>
                                                <label className="radio-inline">
                                                    <input type="radio" name="Dollar Value"
                                                           id="fixed"
                                                           value="fixed"
                                                           checked={isFeeTypeFixed}
                                                    />
                                                        Dollar Value
                                                </label>

                                                <label className="radio-inline">
                                                    <input type="radio" name="feeType"
                                                           id="percentage"
                                                           value="percentage"
                                                           checked={!isFeeTypeFixed}
                                                    />
                                                    Percentage of Subtotal
                                                </label>
                                            </span>
                            </div>

                            <div className={"delivery-zone-box col-lg-12 no-gutter"} style={{marginTop: "10px"}}>
                                <div className="col-lg-12 no-gutter">
                                    <div className="page-header delivery-container mb-5">
                                            <span>
                                                <b>Enable tax on delivery fee: </b><a
                                                href="JavaScript:void(0);"></a>
                                            </span>

                                        <span style={{marginLeft: "5px"}}
                                              onChange={this.handleTaxOnDeliveryFee.bind(this, "taxDeliveryFee")}
                                        >
                                                    <label className="radio-inline">
                                                        <input type="radio"
                                                               name="enableTaxDeliveryFee"
                                                               id="enableTaxDeliveryFee"
                                                               value={"true"}
                                                               checked={this.state.taxDeliveryFee}
                                                        /> Yes
                                                    </label>

                                                    <label className="radio-inline">
                                                        <input type="radio"
                                                               name="disableTaxDeliveryFee"
                                                               id="disableTaxDeliveryFee"
                                                               value={"false"}
                                                               checked={!this.state.taxDeliveryFee}
                                                        /> No
                                                    </label>
                                                </span>
                                    </div>
                                </div>
                            </div>

                            <div className={"delivery-zone-box mb-10 col-lg-12 no-gutter"} style={{ marginTop: "10px" }}>
                                <div className="col-lg-12 no-gutter mt-10 ">
                                    <div className="page-header delivery-container mb-5">
                                      <span>
                                        <b>Do you have your own drivers: </b><a href="JavaScript:void(0);"></a>
                                      </span>

                                        <span style={{ marginLeft: "5px" }}>
                                        <label className="radio-inline">
                                          <input
                                              type="radio"
                                              name="isEmailNotificationEnabled"
                                              id="isEmailNotificationEnabled"
                                              value={"true"}
                                              checked={this.state.isEmailNotificationEnabled}
                                              onChange={this.handleChangeToggle.bind(this)}
                                          /> Yes
                                        </label>

                                        <label className="radio-inline">
                                          <input
                                              type="radio"
                                              name="isEmailNotificationEnabled"
                                              id="isEmailNotificationEnabled"
                                              value={"false"}
                                              checked={!this.state.isEmailNotificationEnabled}
                                              onChange={this.handleChangeToggle.bind(this)}
                                          /> No
                                        </label>
                                      </span>

                                    </div>
                                </div>
                            </div>

                            {
                                this.state.isEmailNotificationEnabled ? (
                                    <div>
                                        <label htmlFor="labelName">Email Address (<span className={"font-weight-light"}>All delivery orders will be notified to the provided email address</span>)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="notifyEmail"
                                            ref="notifyEmail"
                                            aria-describedby="notifyEmail"
                                            placeholder="Enter Email Address"
                                            onChange={this.handleChange.bind(this, "notifyEmail")}
                                            value={this.state.fields["notifyEmail"]}
                                        />
                                        <span style={{color: "red"}} className="form-text">{this.state.errors["notifyEmail"]}</span>
                                    </div>
                                )
                                : this.renderComponentWhenNotifyEmailDisabled()
                            }

                            <hr></hr>

                            <div className={`form-group mt-20`}>
                                <button type="submit" style={{padding: "6px 40px" }} className={"btn btn-primary"}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }

    renderDeliveryForm(deliveryFeeObj) {
        return (
            <div>
                {
                    this.state.editDeliveryFeeConfig && !this.state.addDeliveryFeeConfig ? (
                        <div className="form-group">
                            <label htmlFor="labelName">Delivery
                                Radius ( Minimum
                                Distance )</label>
                            <input type="number"
                                   step="0.01"
                                   pattern="^-?[0-9]\d*\.?\d*$"
                                   className={`form-control ${
                                       !Utils.isEmptyObj(this.state.errors["rangeStart"]) ? 'input-error' : null}`}
                                   id="rangeStart" ref="rangeStart"
                                   value={deliveryFeeObj.rangeStart}
                                   aria-describedby="rangeStart"
                                   placeholder="Enter Delivery Radius in Miles"
                                   name="rangeStart"
                                   disabled={this.state.defaultIndex === 0}
                                   onChange={this.handleChange.bind(this, "rangeStart") }
                            />
                            {!Utils.isEmptyObj(this.state.errors["rangeStart"]) ? (
                                <span style={{color: "red"}} className="form-text">
                                    {this.state.errors["rangeStart"]}
                                </span>
                            ) : null}
                        </div>
                    ) : null
                }


                {
                    !this.state.addDeliveryFeeConfig && !this.state.isEditableRowEnabled || this.state.editDeliveryFeeConfig ? (

                        <div className="form-group">
                            <label htmlFor="labelName">Delivery Radius ( Maximum Distance )</label>
                            <input type="number" step="0.01"
                                   pattern="^-?[0-9]\d*\.?\d*$"
                                   className={`form-control ${
                                       !Utils.isEmptyObj(this.state.errors["rangeEnd"]) ? 'input-error' : null}`}
                                   id="rangeEnd" ref="rangeEnd"
                                   value={deliveryFeeObj.rangeEnd}
                                   aria-describedby="rangeEnd"
                                   placeholder="Enter Delivery Radius in Miles"
                                   name="rangeEnd"
                                   onChange={this.handleChange.bind(this, "rangeEnd") }
                            />

                            {/*show error message*/}
                            {
                                !Utils.isEmptyObj(this.state.errors["rangeEnd"]) ? (
                                    <span style={{color: "red"}} className="form-text">
                                        {this.state.errors["rangeEnd"]}
                                    </span>
                                ) : null
                            }

                        </div>
                    ) : null
                }


                {
                    !this.state.editDeliveryFeeConfig ? (
                        <div>
                            <div className="form-group">
                                <label htmlFor="labelName">Minimum Order Amount</label>
                                <div className="dollar">
                                    <input type="number" pattern="^-?[0-9]\d*\.?\d*$" step="0.01"
                                           className={`form-control ${
                                               !Utils.isEmptyObj(this.state.errors["minAmount"]) ? 'input-error' : null}`}
                                           id="priceStart" ref="priceStart"
                                           value={deliveryFeeObj.priceStart}
                                           aria-describedby="priceStart"
                                           placeholder="Enter Minimum Order Amount"
                                           name="priceStart"
                                           onChange={this.handleChange.bind(this, "priceStart")}
                                           disabled={this.state.addDeliveryFeeConfig}
                                    />
                                </div>

                                {!Utils.isEmptyObj(this.state.errors["minAmount"]) ? (
                                    <span style={{color: "red"}} className="form-text">
                                                                                        {this.state.errors["minAmount"]}</span>
                                ) : null
                                }

                            </div>
                            <div className="form-group">
                                <label htmlFor="labelName">Maximum Order Amount</label>
                                <div className="dollar">
                                    <input type="number" pattern="^-?[0-9]\d*\.?\d*$" step="0.01"
                                           className={`form-control ${
                                               !Utils.isEmptyObj(this.state.errors["maxAmount"]) ? 'input-error' : null}`}
                                           value={deliveryFeeObj.priceEnd}
                                           id="priceEnd" ref="priceEnd"
                                           aria-describedby="priceEnd"
                                           placeholder="Enter Maximum Order Amount"
                                           name="priceEnd"
                                           onChange={this.handleChange.bind(this, "priceEnd")}
                                    />
                                </div>


                                {!Utils.isEmptyObj(this.state.errors["maxAmount"]) ? (
                                    <span style={{color: "red"}} className="form-text">
                                        {this.state.errors["maxAmount"]}
                                    </span>
                                ) : null}

                            </div>
                            <div className="form-group">
                                <label htmlFor="labelName">Delivery Fee ({this.renderFeeType()})</label>
                                <input type="number" pattern="^-?[0-9]\d*\.?\d*$" step="0.01"
                                       className={`form-control ${
                                           !Utils.isEmptyObj(this.state.errors["deliveryFee"]) ? 'input-error' : null}`}
                                       id="fee" ref="fee"
                                       value={deliveryFeeObj.fee}
                                       aria-describedby="fee"
                                       placeholder="Enter Delivery Fee"
                                       name="fee"
                                       onChange={this.handleChange.bind(this, "fee")}
                                />
                                {!Utils.isEmptyObj(this.state.errors["deliveryFee"]) ? (
                                    <span style={{color: "red"}} className="form-text">
                                                                                {this.state.errors["deliveryFee"]}
                                                                            </span>
                                ) : null}
                            </div>
                        </div>
                    ) : null
                }

                <hr></hr>

                <div className="form-group">
                    <button type="submit" style={{padding: "6px 40px" }} className={this.state.isBtnDisabled ? "btn-save btn btn-primary" : "btn btn-primary"}>Save</button>
                </div>

            </div>
        );
    }


    render() {
        const fields = this.state.fields;
        const feeMatrix = this.state.feeMatrix;
        const deliveryFeeObj = this.state.deliveryFeeObj;
        let activeLocation = this.state.activeLocation;
        const deliveryInfo = activeLocation.deliveryInfo;
        let notifyEmail = "";

        if(activeLocation.hasOwnProperty("deliveryInfo") && !Utils.isEmptyObj(deliveryInfo)){
            notifyEmail = deliveryInfo.notifyEmail;
        }

        let isFeeTypeFixed = true;
        let taxDeliveryFee = "No";
        let notificationEmail = "No";
        let Comp = null;

        if (!Utils.isEmptyObj(fields) && fields.hasOwnProperty("feeType")) {

            if (fields["feeType"] == 'fixed') {
                isFeeTypeFixed = "Dollar Value";
            } else {
                isFeeTypeFixed = "Percentage";
            }


            if (fields["taxDeliveryFee"] == true) {
                taxDeliveryFee = "Yes";
            }

            // Comp = (
            //     <span>
            //         <a data-tip={`All delivery orders will be notified to <b>${this.state.fields["notifyEmail"]}`}
            //            className={'color-styl tooltip-button'}
            //            style={{ cursor : 'pointer' }}><i className="fa fa-info-circle"></i>
            //         </a>
            //         <ReactTooltip place="right" wrapper="span"/>
            //     </span>
            // )

            if (!Utils.isEmpty(fields["notifyEmail"] )) {
                Comp = (
                    <span className={"deliverysetting-text"}>
                        Yes
                        <a data-tip={`All delivery orders will be notified to ${this.state.fields["notifyEmail"]}`}
                           className={'color-styl tooltip-button ml-5'}
                           style={{ cursor : 'pointer' }}><i className="fa fa-info-circle"></i>
                        </a>
                        <ReactTooltip place="right" wrapper="span"/>
                    </span>
                )
            }else{
                Comp = (
                    <span className={"deliverysetting-text"}>
                        No
                    </span>
                )
            }

        }

        return (
            <div className="deliveryConfig-container deliveryfee-section col-lg-8 col-md-12">
                <div className="marginTop">
                    <div className="row updateDeliveryConfigForm mb-30">
                        <div className={"delivery-zone-box col-lg-12 mt-10"}>
                            <div className="col-lg-12 no-gutter">

                                {
                                    this.state.errors && this.state.errors["errors"] ? (
                                        <div className="col-lg-12 mt-20 mb-20  alert alert-danger"
                                             role="alert" style={{marginBottom: 0}}>
                                            <span
                                                className="form-text">{this.state.errors["errors"]}</span>
                                        </div>) : null

                                }


                                {
                                    this.state.isDeliveryInfoUpdated && !Utils.isEmpty(this.state.successMsg) ? (
                                        this.showSuccessMsg()
                                    ) : null
                                }

                            </div>

                        </div>

                        {
                            feeMatrix.length > 0 ? (
                                <div className="col-lg-12">
                                    <h4 id="translations" className="page-header"><b>Delivery Settings</b></h4>

                                    <div className="col-lg-12 no-gutter bg-table notify-table">
                                        <div className={"edit-deliveryinfo"}>
                                            <span><b>Basic Information</b></span>
                                            <span
                                                style={{display: "inline-flex"}}
                                                className={"pull-right"}
                                            >
                                            <b style={{"marginRight": 5}}>
                                                 Edit
                                            </b>

                                            <a href="JavaScript:void(0);">
                                                <i className={"fa fa-edit fa-lg text-dark mr-5"}onClick={this.handleNotifyEmail.bind(this)}></i>
                                            </a>
                                        </span>
                                        </div>

                                        <div className="col-xs-12 no-gutter">
                                            <div className="col-xs-3">
                                                <span className={"deliverysetting-text"}><b>Fee type</b></span>
                                            </div>
                                            <div className="col-xs-5">
                                                <span className={"deliverysetting-text"}><b>Delivery fee is taxable</b></span>
                                            </div>
                                            <div className="col-xs-4">
                                                <span className={"deliverysetting-text"}> <b>Your own drivers</b></span>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 no-gutter mt-10">
                                            <div className="col-xs-3">
                                                <span className={"deliverysetting-text"}>{isFeeTypeFixed}</span>
                                            </div>
                                            <div className="col-xs-5">
                                                <span className={"deliverysetting-text"}>{taxDeliveryFee}</span>
                                            </div>
                                            <div className="col-xs-4">
                                                {Comp}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }

                        <div className="col-lg-12 mt-20">
                            <h4 id="translations"
                                className="page-header"
                                style={{margin: 0}}
                            ><b>
                                Delivery Zone Settings</b>
                            </h4>
                        </div>
                        <div>

                            {
                                this.renderDeliveryFeeRow()
                            }
                        </div>

                        {
                            this.state.toggleNotifyModal ?
                                <Modal
                                    show={this.state.toggleNotifyModal}
                                    closeCallback={this.closeNotificationModal}
                                    customClass="custom_modal_class"
                                    headerCustomClass={"modal-header-custom"}
                                    title={this.state.modalTitle}
                                >
                                        <div className="section export-order-container">
                                            {this.renderNotifyEmailForm()}
                                        </div>

                                </Modal> : null
                        }

                        {
                            this.state.showZoneModal ?
                                <Modal
                                    show={this.state.showZoneModal}
                                    closeCallback={this.handleCancel}
                                    customClass="custom_modal_class"
                                    headerCustomClass={"modal-header-custom"}
                                    title={this.state.modalTitle}>
                                    <div className={""}>
                                        <div className="section export-order-container">
                                            <form name="updateLocationForm"
                                                  onSubmit={this.updateDeliveryFormSubmit.bind(this)}>
                                                <div className={"row"}>
                                                    <div className="container" style={{
                                                        maxWidth: '100%',
                                                        padding: "5px 20px 15px 20px"
                                                    }}>

                                                        <div className="col-sm-12 delivery-input-container">
                                                            {this.renderDeliveryForm(deliveryFeeObj)}
                                                        </div>

                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </Modal> : null
                        }

                        <div className="col-lg-12 add-zone-container">
                            <div style={{ marginTop: "10px"}}>
                                <btn
                                    className={"btn btn-primary mt-20"}
                                    onClick={this.addNewZone.bind(this)}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i> Add Zone
                                </btn>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/delivery-config.js